/**
 * Texto legal único de la empresa — fuente de verdad.
 *
 * Lo importan tanto los PDFs (OrdenPDF, InformePericialPDF) como
 * el portal público de Seguimiento, para que el cliente vea y firme
 * EXACTAMENTE el mismo texto que aparece impreso en la OT.
 */
export const CONDICIONES_TITULO = 'CONDICIONES GENERALES DEL SERVICIO TÉCNICO';

export const CONDICIONES_GENERALES = [
  {
    titulo: '1. Aceptación del servicio',
    cuerpo:
      'La entrega del dispositivo al servicio técnico implica la aceptación expresa de las presentes condiciones generales por parte del cliente, autorizando la manipulación, desmontaje, diagnóstico y reparación del terminal o dispositivo entregado.',
  },
  {
    titulo: '2. Estado previo del dispositivo',
    cuerpo:
      'El cliente declara que el dispositivo puede presentar daños previos visibles o internos no apreciables durante la recepción inicial. El servicio técnico no se responsabiliza de averías ocultas, fallos preexistentes, defectos internos, daños derivados de golpes, humedad, sulfatación, manipulaciones anteriores, reparaciones de terceros o desgaste propio del uso del dispositivo que pudieran manifestarse antes, durante o después de la intervención técnica.',
  },
  {
    titulo: '3. Pérdida de estanqueidad',
    cuerpo:
      'Toda intervención técnica que implique apertura, desmontaje o manipulación del dispositivo puede afectar a las condiciones originales de sellado, resistencia al agua, polvo o estanqueidad certificada por el fabricante. El servicio técnico no garantiza el mantenimiento de certificaciones IP o resistencia al agua tras la reparación, salvo indicación expresa por escrito.',
  },
  {
    titulo: '4. Datos y copias de seguridad',
    cuerpo:
      'El cliente es el único responsable de realizar copia de seguridad de la información contenida en el dispositivo antes de su entrega. El servicio técnico no se responsabiliza de la pérdida parcial o total de datos, aplicaciones, configuraciones, cuentas, archivos, fotografías o información almacenada como consecuencia de pruebas, diagnósticos, reparaciones, actualizaciones de software, restauraciones o fallos del propio dispositivo.',
  },
  {
    titulo: '5. Fallos intermitentes o no reproducibles',
    cuerpo:
      'El servicio técnico únicamente actuará sobre incidencias técnicamente verificables y reproducibles. No se garantiza la detección de fallos intermitentes, aleatorios o no reproducibles durante el proceso de diagnóstico, ni podrán considerarse acreditadas incidencias basadas exclusivamente en apreciaciones subjetivas del usuario sin evidencia técnica objetiva.',
  },
  {
    titulo: '6. Garantía de reparación',
    cuerpo:
      'La garantía cubre exclusivamente la intervención o componente sustituido y únicamente respecto a defectos derivados directamente de la reparación efectuada. Quedan excluidos de garantía: golpes, humedad, sulfatación, mal uso, desgaste, manipulación por terceros, daños eléctricos, sobrecargas, actualizaciones de software, daños accidentales, roturas posteriores, y averías no relacionadas con la reparación inicial. La manipulación del dispositivo por terceros anula automáticamente cualquier garantía ofrecida por este servicio técnico.',
  },
  {
    titulo: '7. Componentes y piezas',
    cuerpo:
      'Salvo indicación expresa, las reparaciones podrán realizarse mediante componentes compatibles, reacondicionados, recuperados u originales según disponibilidad técnica y comercial. Las diferencias estéticas mínimas, tolerancias de fabricación o variaciones propias del componente instalado no se considerarán defecto de reparación.',
  },
  {
    titulo: '8. Dispositivos manipulados o con daños graves',
    cuerpo:
      'El servicio técnico se reserva el derecho de rechazar reparaciones en dispositivos con manipulación previa, soldaduras alteradas, daños estructurales severos, placas reparadas previamente, sulfatación avanzada o riesgo técnico elevado. Asimismo, determinados dispositivos pueden sufrir daños irreversibles durante el proceso de desmontaje debido a su estado previo, antigüedad o deterioro interno, eximiéndose el servicio técnico de responsabilidad cuando dichos daños no sean atribuibles a negligencia directa.',
  },
  {
    titulo: '9. Limitación de responsabilidad',
    cuerpo:
      'La responsabilidad máxima del servicio técnico quedará limitada, en cualquier caso, al importe efectivamente abonado por la reparación realizada. El servicio técnico no responderá de pérdidas indirectas, lucro cesante, pérdida de información, pérdida comercial, perjuicios profesionales ni daños derivados de la imposibilidad temporal de uso del dispositivo.',
  },
  {
    titulo: '10. Dispositivos no recogidos',
    cuerpo:
      'Los dispositivos no retirados en un plazo de 30 días desde la comunicación de finalización de reparación o presupuesto podrán devengar gastos de almacenamiento. Transcurridos 90 días sin retirada ni comunicación por parte del cliente, el servicio técnico podrá entender el dispositivo como abandonado, reservándose el derecho de gestión, reciclaje o destrucción conforme a la normativa aplicable para cubrir costes técnicos y de almacenamiento.',
  },
  {
    titulo: '11. Derecho de verificación técnica',
    cuerpo:
      'Toda reclamación deberá ir acompañada de la correspondiente verificación técnica por parte del servicio técnico. La negativa del cliente a facilitar nuevamente el dispositivo para comprobación imposibilitará la validación objetiva de la incidencia reclamada.',
  },
];

/** Texto plano (para mostrar en modales como string si hace falta). */
export const CONDICIONES_GENERALES_TEXTO = CONDICIONES_GENERALES
  .map((c) => `${c.titulo}\n${c.cuerpo}`)
  .join('\n\n');
